import type { Ssm5TripTime } from '@packages/domain/ssm5';

/** How many decimals the supply voltage shows. */
const VOLTAGE_DECIMALS = 1;

/** How many decimals the time count shows, in seconds, as the panel header shows its time. */
const TIME_DECIMALS = 3;

const MS_PER_SECOND = 1000;

/**
 * Write a supply voltage as the design does: one decimal and the unit, "12.2V".
 *
 * @param voltage - the voltage in volts, if the vehicle reported a valid one
 * @returns the text, or undefined without a voltage
 */
export function formatSupplyVoltage(voltage: number | undefined): string | undefined {
    return voltage === undefined ? undefined : `${voltage.toFixed(VOLTAGE_DECIMALS)}V`;
}

/**
 * Write the time into the ignition cycle in seconds, as the panel header writes its time: "571.600".
 *
 * @param tripTime - the ignition cycle and the time into it, if the vehicle reported them
 * @returns the text, or undefined without them
 */
export function formatTimeCount(tripTime: Ssm5TripTime | undefined): string | undefined {
    return tripTime === undefined ? undefined : (tripTime.elapsedMs / MS_PER_SECOND).toFixed(TIME_DECIMALS);
}

/**
 * Write the ignition cycle count, as the panel header writes its trip: "585".
 *
 * @param tripTime - the ignition cycle and the time into it, if the vehicle reported them
 * @returns the text, or undefined without them
 */
export function formatTripCount(tripTime: Ssm5TripTime | undefined): string | undefined {
    return tripTime === undefined ? undefined : String(tripTime.trip);
}
